import { Component } from '@angular/core';

@Component({
  selector: 'app-create-stock',
  template: ``,
  styleUrls: []
})
export class CreateStockComponent {

}
